module.exports = function isBoolean(x) {
  return x === true || x === false;
};


//////////////////
// WEBPACK FOOTER
// ./~/tcomb/lib/isBoolean.js
// module id = 176
// module chunks = 0